<template>
  <div class="d-flex align-center">
    <div v-for="file in uploadedTerms" :key="file.id">
      <v-chip
        color="grey lighten-3"
        target="_blank"
        class="px-1"
      >
        <div class="d-flex px-1">
          <span
            class="d-flex mr-1 px-2 rounded"
            :class="hasSignedTerms ? 'green' : 'grey'"
          >
            <span class="caption white--text">
              <v-icon v-if="hasSignedTerms" x-small> mdi-check </v-icon>
              {{ $t(`appointment.label.${hasSignedTerms ? 'signedTerm' : 'notSignedTerm'}`) }}
            </span>
          </span>
          <span class="d-block text-truncate">
            {{ file.name }}
          </span>
        </div>
      </v-chip>

      <v-divider class="white mx-1" vertical />

      <v-tooltip top>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            @click="openFile(file.url)"
            v-bind="attrs"
            v-on="on"
            class="grey lighten-3"
            small
            icon
          >
            <v-icon color="primary" small>
              mdi-download
            </v-icon>
          </v-btn>
        </template>
        <span>{{ $t('appointment.label.download') }}</span>
      </v-tooltip>

      <v-divider v-if="!file.external_id" class="white mx-1" vertical />

      <v-tooltip v-if="!file.external_id" top>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            @click="openReplaceTermModal()"
            v-bind="attrs"
            v-on="on"
            class="grey lighten-3"
            small
            icon
          >
            <v-icon color="primary" small>
              mdi-file-replace
            </v-icon>
          </v-btn>
        </template>
        <span>{{ $t('appointment.label.replace') }}</span>
      </v-tooltip>

      <v-divider v-if="file.external_id" class="white mx-1" vertical />

      <v-tooltip v-if="file.external_id" top>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-if="!isGettingClickSignDataLoading"
            @click="clickSignData(file.external_id, false)"
            class="grey lighten-3"
            v-bind="attrs"
            v-on="on"
            small
            icon
          >
            <v-icon color="primary" small>
              mdi-account-multiple-outline
            </v-icon>
          </v-btn>
          <v-btn v-else small icon>
            <v-progress-circular color="primary" size="12" width="2" indeterminate />
          </v-btn>
        </template>
        <span>{{$t('appointment.label.showClickSignSignatures')}}</span>
      </v-tooltip>

      <v-divider v-if="file.external_id" class="white mx-1" vertical />

      <v-tooltip v-if="isAdminPath && file.external_id" top>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-if="!isGoingToClickSignLoading"
            @click="clickSignData(file.external_id, true)"
            class="grey lighten-3"
            v-bind="attrs"
            v-on="on"
            small
            icon
          >
            <v-icon color="primary" small>
              mdi-open-in-new
            </v-icon>
          </v-btn>
          <v-btn v-else small icon>
            <v-progress-circular color="primary" size="12" width="2" indeterminate />
          </v-btn>
        </template>
        <span>{{$t('appointment.label.showOnClickSign')}}</span>
      </v-tooltip>
    </div>

    <ModalAppointmentSignedTerm :termData="termData" />
    <ModalAppointmentTermReplace :isAdmin="isAdminPath" :key="activeModal" />
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import {
  getClickSignDocument,
  getClickSignDocumentUrl,
} from '@/services/appointment/appointmentService'

import ModalAppointmentSignedTerm from './ModalAppointmentSignedTerm.vue'
import ModalAppointmentTermReplace from './ModalAppointmentTermReplace.vue'

export default {
  name: 'AppointmentFilesTermList',

  components: {
    ModalAppointmentSignedTerm,
    ModalAppointmentTermReplace,
  },

  props: {
    terms: {
      type: Array,
      default: [],
    },

    signedTerms: {
      type: Array,
      default: [],
    },
  },

  computed: {
    ...mapGetters(['activeModal']),

    hasSignedTerms() {
      return this.signedTerms.length >= 1
    },

    uploadedTerms() {
      return this.signedTerms.length ? this.signedTerms : this.terms
    },

    getTermFromAdminOrWeb() {
      return this.$route?.path.includes('admin') ? 'admin' : 'web'
    },

    isAdminPath() {
      return this.getTermFromAdminOrWeb === 'admin'
    },
  },

  methods: {
    ...mapMutations(['openModal']),

    clickSignData(documentId, openClickSign) {
      openClickSign
        ? this.goToClickSignLink(documentId)
        : this.getClickSignInfoAndShowModal(documentId)
    },

    goToClickSignLink(documentId) {
      this.isGoingToClickSignLoading = true

      getClickSignDocumentUrl(documentId)
        .then(({ data }) => this.openFile(data))
        .catch(({ data }) => this.$store.dispatch('showErrorMessage', data.message))
        .finally(() => this.isGoingToClickSignLoading = false)
    },

    getClickSignInfoAndShowModal(documentId) {
      this.isGettingClickSignDataLoading = true

      getClickSignDocument(this.getTermFromAdminOrWeb, documentId)
        .then(({ data }) => this.openSignedData(data))
        .catch(({ data }) => this.$store.dispatch('showErrorMessage', data.message))
        .finally(() => this.isGettingClickSignDataLoading = false)
    },

    openFile(url) {
      window.open(url, '_blank');
    },

    openSignedData(data) {
      this.termData = null

      this.$nextTick(() => {
        this.termData = data
        this.openModal('SIGNED_TERM_INFO_MODAL')
      })
    },

    openReplaceTermModal() {
      this.openModal('REPLACE_TERM_MODAL')
    }
  },

  data() {
    return {
      termData: null,
      isGoingToClickSignLoading: false,
      isGettingClickSignDataLoading: false,
    }
  }
}
</script>
